/* v2 | 5 November 2026 | Suppress homepage video UI; preserve responsive background video and reduced motion. */
(function () {
  'use strict';
  var controllers = new Map();
  function init(section) {
    if (controllers.has(section)) return;
    var videos = Array.from(section.querySelectorAll('video[data-video-src]'));
    if (!videos.length) return;
    var viewport = window.matchMedia('(max-width: 640px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var active = null;
    var visible = false;
    var userChoice = null;
    var destroyed = false;
    // Hide playback toggle on homepages only; keep it available on other pages.
    // Responsive playback, off-screen pausing and reduced-motion handling remain active.
    var isHomepage = !!(document.body && document.body.classList.contains('template-index'));
    var button = null;
    if (!isHomepage) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'flite-video-toggle';
      button.hidden = true;
      button.innerHTML = '<span aria-hidden="true" class="flite-video-toggle-icon"></span><span class="flite-visually-hidden" data-video-control-label></span>';
      (section.querySelector('[data-flite-video-frame]') || section).appendChild(button);
    }
    function updateButton() {
      if (!button) return;
      var playing = active && !active.paused;
      var label = playing ? 'Pause video' : 'Play video';
      button.hidden = !active || !active.getAttribute('data-video-src');
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', String(!!playing));
      button.classList.toggle('is-playing', !!playing);
      button.querySelector('[data-video-control-label]').textContent = label;
    }
    function play(video) {
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(updateButton);
    }
    function sync() {
      if (destroyed) return;
      var next = videos.find(function (video) {
        return viewport.matches ? video.classList.contains('hidden-tablet-and-up') : video.classList.contains('hidden-phone');
      });
      if (active !== next) {
        if (active) active.pause();
        active = next || null;
      }
      videos.forEach(function (video) { if (video !== active && !video.paused) video.pause(); });
      if (!active) { updateButton(); return; }
      var automatic = active.getAttribute('data-flite-autoplay') === 'true';
      var shouldPlay = visible && !document.hidden && (userChoice === 'play' || (userChoice !== 'pause' && automatic && !reduced.matches));
      if (shouldPlay) {
        var src = active.getAttribute('data-video-src');
        if (src && !active.getAttribute('src')) { active.setAttribute('src', src); active.load(); }
        if (src && active.paused) play(active);
      } else if (!active.paused) active.pause();
      updateButton();
    }
    function toggle() {
      if (!active) return;
      userChoice = active.paused ? 'play' : 'pause';
      sync();
    }
    function mediaListen(query) {
      if (query.addEventListener) query.addEventListener('change', sync);
      else query.addListener(sync);
    }
    function mediaRemove(query) {
      if (query.removeEventListener) query.removeEventListener('change', sync);
      else query.removeListener(sync);
    }
    if (button) button.addEventListener('click', toggle);
    videos.forEach(function (video) {
      video.removeAttribute('autoplay');
      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      video.addEventListener('ended', updateButton);
      video.addEventListener('error', updateButton);
    });
    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.target === section) visible = entry.isIntersecting; });
        sync();
      }, { threshold: 0.01 });
      observer.observe(section);
    } else visible = true;
    var rect = section.getBoundingClientRect();
    if (rect.bottom > 0 && rect.top < window.innerHeight) visible = true;
    mediaListen(viewport);
    mediaListen(reduced);
    document.addEventListener('visibilitychange', sync);
    controllers.set(section, function () {
      destroyed = true;
      if (observer) observer.disconnect();
      mediaRemove(viewport);
      mediaRemove(reduced);
      document.removeEventListener('visibilitychange', sync);
      videos.forEach(function (video) {
        video.pause();
        ['play', 'pause', 'ended', 'error'].forEach(function (event) { video.removeEventListener(event, updateButton); });
      });
      if (button) button.remove();
      controllers.delete(section);
    });
    sync();
  }
  function scan(root) {
    if (root.matches && root.matches('[data-flite-video-section]')) init(root);
    root.querySelectorAll('[data-flite-video-section]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (destroy, section) { if (section === event.target || event.target.contains(section)) destroy(); });
  });
})();
